import { DatePicker, Form, Input } from 'antd';
import moment from 'moment';
import React, { Fragment } from 'react';
import useDebouncedSearch from '../../../../../../hooks/useDebouncedSearch';
import useBirthPlaces from '../../../../queries/useBirthPlaces';
import useDadataAddresses from '../../../../queries/useDadataAddresses';
import styles from '../../modalStyles.module.scss';
import AddressSelect from '../AddressSelect/AddressSelect';
import CountrySelect from '../CountrySelect/CountrySelect';
import ReceiptSelect from '../ReceiptSelect/ReceiptSelect';
import {
  emailValidator,
  numFieldValidator,
  phoneValidator,
} from '../../../../utils/validators';
import { dateFormatList } from '../../../../constants/dateFormatList';

const ContractorModalPersonMode = ({
  getFieldDecorator,
  getOptions,
  setFieldsValue,
  getFieldValue,
  editingCounterparty,
}) => {
  const [_search, setSearch, debouncedSearch] = useDebouncedSearch();
  const { data: dadataAddresses, isFetching: dadataAddressesLoading } =
    useDadataAddresses(debouncedSearch);
  const [_searchCity, setSearchCity, debouncedSearchCity] =
    useDebouncedSearch();
  const { data: birthPlaces, isFetching: birthPlacesLoading } =
    useBirthPlaces(debouncedSearchCity);

  return (
    <>
      <div className={styles.flex}>
        <Form.Item label="Фамилия" className={styles.flexFull}>
          {getFieldDecorator('surName', {
            initialValue: editingCounterparty?.surName,
            ...getOptions('Введите фамилию.'),
          })(<Input placeholder={'Введите текст'} />)}
        </Form.Item>
        <Form.Item label="Имя" className={styles.flexFull}>
          {getFieldDecorator('firstName', {
            initialValue: editingCounterparty?.firstName,
            ...getOptions('Введите имя.'),
          })(<Input placeholder={'Введите текст'} />)}
        </Form.Item>
        <Form.Item label="Отчество" className={styles.flexFull}>
          {getFieldDecorator('patrName', {
            initialValue: editingCounterparty?.patrName,
          })(<Input placeholder={'Введите текст'} />)}
        </Form.Item>
      </div>
      <div className={styles.flex}>
        <Form.Item label="Почта" className={styles.flexFull}>
          {getFieldDecorator('email', {
            initialValue: editingCounterparty?.email,
            rules: [
              {
                validator: emailValidator,
              },
            ],
          })(<Input placeholder={'Введите почту'} />)}
        </Form.Item>
        <Form.Item label="Телефон" className={styles.flexFull}>
          {getFieldDecorator('phoneNumber', {
            initialValue: editingCounterparty?.phoneNumber,
            rules: [
              {
                validator: phoneValidator,
              },
            ],
          })(<Input type="tel" placeholder="+79876543210" />)}
        </Form.Item>
      </div>

      <div className={styles.flex}>
        <CountrySelect
          editingCounterparty={editingCounterparty}
          getFieldDecorator={getFieldDecorator}
          className={styles.flexFull}
        />
        <div className={styles.passportInputs}>
          <Form.Item label="Серия паспорта" className={styles.flexFull}>
            {getFieldDecorator('passportSeries', {
              initialValue: editingCounterparty?.individualInfo?.passportSeries,
            })(<Input placeholder={'Введите серию'} />)}
          </Form.Item>
          <Form.Item label="Номер паспорта" className={styles.flexFull}>
            {getFieldDecorator('passportNumber', {
              initialValue: editingCounterparty?.individualInfo?.passportNumber,
              rules: [
                {
                  validator: numFieldValidator,
                },
              ],
            })(<Input placeholder={'Введите номер'} />)}
          </Form.Item>
        </div>
      </div>

      <div className={styles.flex}>
        <Form.Item label="Подразделение" className={styles.flexFull}>
          {getFieldDecorator('passportSubDivision', {
            initialValue:
              editingCounterparty?.individualInfo?.passportSubDivision,
          })(<Input placeholder={'Введите текст'} />)}
        </Form.Item>
        <Form.Item label="Кем выдан" className={styles.flexFull}>
          {getFieldDecorator('passportIssued', {
            initialValue: editingCounterparty?.individualInfo?.passportIssued,
          })(<Input placeholder={'Введите текст'} />)}
        </Form.Item>
      </div>

      <div className={styles.flex}>
        <Form.Item label="Дата выдачи" className={styles.flexFull}>
          {getFieldDecorator('passportDate', {
            initialValue:
              editingCounterparty?.individualInfo?.passportDate &&
              moment(editingCounterparty.individualInfo.passportDate),
          })(
            <DatePicker
              placeholder={'Введите дату'}
              className={styles.datePicker}
              format={dateFormatList}
            />
          )}
        </Form.Item>
        <Form.Item label="Дата рождения" className={styles.flexFull}>
          {getFieldDecorator('dateBirth', {
            initialValue:
              editingCounterparty?.individualInfo?.dateBirth &&
              moment(editingCounterparty.individualInfo.dateBirth),
          })(
            <DatePicker
              placeholder={'Введите дату'}
              className={styles.datePicker}
              format={dateFormatList}
            />
          )}
        </Form.Item>
      </div>
      <ReceiptSelect
        getFieldDecorator={getFieldDecorator}
        editingCounterparty={editingCounterparty}
        getOptions={getOptions}
      />
      {getFieldDecorator('registrationAddress', {
        preserve: true,
        initialValue: editingCounterparty?.registrationAddress,
      })(<Fragment />)}
      <AddressSelect
        placeholder="Введите город и улицу"
        defaultValue={editingCounterparty?.registrationAddress}
        addresses={[
          ...dadataAddresses,
          editingCounterparty?.registrationAddress,
        ].filter(Boolean)}
        setSearch={setSearch}
        loading={dadataAddressesLoading}
        getFieldValue={getFieldValue}
        label="Адрес регистрации"
        formKey="registrationAddress"
        setFieldsValue={setFieldsValue}
        nameKey={'fullAddress'}
      />
      {getFieldDecorator('cityBirth', {
        preserve: true,
        initialValue: editingCounterparty?.individualInfo?.cityBirth,
      })(<Fragment />)}
      <AddressSelect
        placeholder="Введите город"
        defaultValue={editingCounterparty?.individualInfo?.cityBirth}
        addresses={[
          ...birthPlaces,
          editingCounterparty?.individualInfo?.cityBirth,
        ].filter(Boolean)}
        setSearch={setSearchCity}
        loading={birthPlacesLoading}
        getFieldValue={getFieldValue}
        label="Место рождения"
        formKey="cityBirth"
        setFieldsValue={setFieldsValue}
        nameKey={'fullCity'}
      />
    </>
  );
};

export default ContractorModalPersonMode;
